<template>
    <div class="permission">
        <div style="display: flex;">
            <label>
                <input type="checkbox" :value="permission.permissions"  @change.stop.prevent="togglePermission(permission)" :checked="isChecked">
                <span>{{permission.text}}</span>
            </label>

            <template v-if="isRoot && permission.inner?.length">
                <i class="fa fa-fw fa-chevron-right" @click="expand" v-show="isCollapsed" style="cursor: pointer"/>
                <i class="fa fa-fw fa-chevron-down" @click="collapse" v-show="!isCollapsed" style="cursor: pointer"/>
            </template>
        </div>

        <div v-show="!isCollapsed" v-for="innerPermission in permission.inner" class="permission" style="padding-left: 40px;">
            <permission :permission="innerPermission"
                        v-model="currentPermissions"
                        @checked="check"
                        :key="innerPermission.permissions"/>
        </div>
    </div>
</template>

<script>
import Vue from "vue";

export default {
    name: 'permission',
    props: {
        permission: {
            type: Object,
            required: false
        },
        userPermission: {
            type: Array,
            required: true,
        },
        isRoot: {
            type: Boolean,
            default: false,
        }
    },
    model: {
        prop: 'userPermission',
        event: 'change'
    },
    data () {
        return {
            currentPermissions: this.userPermission.sort(),
            isCollapsed: this.isRoot,
        };
    },

    computed: {
        hasPermission () {
            return this.currentPermissions.includes(this.permission.permissions);
        },
        isChecked () {
            return this.hasPermission;
        },
    },

    methods: {
        togglePermission() {
            if (this.hasPermission) {
                this.uncheck();
            } else {
                this.check()
            }
        },
        check (silent) {
            if (!this.hasPermission) {
                this.currentPermissions.push(this.permission.permissions);
                this.currentPermissions.sort();
            }
            if (silent !== true) {
                this.$emit('change', this.currentPermissions);
                this.$emit('checked', this.currentPermissions);
            }
        },
        uncheck (silent) {
            this.$children.forEach((item, index) => {
                item.uncheck();
            })

            let index = this.currentPermissions.indexOf(this.permission.permissions);
            if (index > -1) {
                this.currentPermissions.splice(index, 1);
            }

            if (silent !== true) {
                this.$emit('change', this.currentPermissions);
            }
        },
        collapse() {
            this.isCollapsed = true;
        },
        expand() {
            this.isCollapsed = false;
        }
    },

    watch: {
    }
}
</script>

<style>
#userDialog {
    width: 700px;
}
</style>
